import { api } from '../../client';

export interface InvoiceLineItemDto {
  id?: string;
  description: string;
  quantity: number;
  price: number;
  tax_percentage: number;
  line_total: number;
}

export interface InvoiceDto {
  id: string;
  invoice_number: string;
  customer_id: string;
  customer_name: string;
  invoice_date: string;
  due_date: string;
  reference_po_number?: string;
  notes?: string;
  terms_and_conditions?: string;
  subtotal?: number;
  tax_amount?: number;
  amount: number;
  balance_due: number;
  status: 'draft' | 'sent' | 'paid' | 'overdue';
  line_items?: InvoiceLineItemDto[];
}

export const salesInvoicesApi = {
  async list(
    search?: string
  ): Promise<{ data?: InvoiceDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/sales/invoices${q}`) as Promise<{ data: InvoiceDto[] }>;
  },

  async get(id: string): Promise<{ data?: InvoiceDto; message?: string }> {
    return api.get(`/sales/invoices/${id}`) as Promise<{ data: InvoiceDto }>;
  },

  async create(data: {
    customer_id: string;
    invoice_number?: string;
    invoice_date: string;
    due_date: string;
    reference_po_number?: string;
    notes?: string;
    terms_and_conditions?: string;
    status?: 'draft' | 'sent' | 'paid';
    line_items: Array<{
      description: string;
      quantity: number;
      price: number;
      tax_percentage?: number;
    }>;
  }): Promise<{ data?: InvoiceDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/sales/invoices', data) as Promise<{
      data: InvoiceDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      customer_id?: string;
      invoice_number?: string;
      invoice_date?: string;
      due_date?: string;
      reference_po_number?: string;
      notes?: string;
      terms_and_conditions?: string;
      status?: 'draft' | 'sent' | 'paid';
      line_items?: Array<{
        description: string;
        quantity: number;
        price: number;
        tax_percentage?: number;
      }>;
    }
  ): Promise<{ data?: InvoiceDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/sales/invoices/${id}`, data) as Promise<{
      data: InvoiceDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/sales/invoices/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },

  async send(id: string): Promise<{ data?: InvoiceDto; message?: string }> {
    return api.post(`/sales/invoices/${id}/send`, {}) as Promise<{ data: InvoiceDto; message?: string }>;
  },
};
